export default __webpack_public_path__ + "6af5b04f6092488db0590e8fa18a0cd4.png";